import { render, staticRenderFns } from "./search-bulk-messages.vue?vue&type=template&id=54f84d2c&scoped=true&"
import script from "./search-bulk-messages.vue?vue&type=script&lang=js&"
export * from "./search-bulk-messages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f84d2c",
  null
  
)

export default component.exports